import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchFuelPriceHistory,
  type FuelPriceHistoryEntry,
} from '../repositories/fuelPrices.js';

/**
 * F-02: `fuel_price_history` から直近 N 件取得する React Query hook（デフォ 10 件）。
 *
 * cache key: `['fuelPriceHistory', tenantId, limit]`
 */
export function useFuelPriceHistory(
  tenantId: string | null | undefined,
  limit: number = 10,
): UseQueryResult<FuelPriceHistoryEntry[], Error> {
  return useQuery({
    queryKey: ['fuelPriceHistory', tenantId, limit],
    queryFn: () => fetchFuelPriceHistory(tenantId as string, limit),
    enabled: !!tenantId,
    staleTime: 30 * 1000,
  });
}
